"use client";

import { useTranslation } from "react-i18next";
import { usePathname } from "next/navigation";
import Link from "next/link";
import AreaContentBlock from "./AreaContentBlock";
import { getLocaleFromPath } from "../lib/i18n/utils";

export default function HomeAreaSection() {
  const { t } = useTranslation();
  const pathname = usePathname();
  const locale = getLocaleFromPath(pathname);

  return (
    <section className="relative w-full grid grid-cols-1 lg:grid-cols-2 mt-4 md:mt-0">
      <div
        className="relative min-h-[25rem] md:min-h-[31.25rem] lg:h-screen"
        style={{
          backgroundImage: "url(/images/area/area-left.webp)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          className="absolute left-4 top-4 bottom-4 md:left-[3.125rem] md:bottom-[3.125rem] md:top-auto lg:left-8 lg:bottom-8 lg:top-auto right-4 md:right-[3.125rem] lg:right-8 w-auto min-h-[22.1875rem] px-6 py-8 md:px-8 md:py-10 lg:py-12 xl:py-14 flex items-start bg-ui-card/85 max-w-full box-border"
          style={{ minWidth: 0 }}
        >
            <AreaContentBlock
              variant="homepage"
              headingLevel="h2"
              title={
                <Link href={locale === "el" ? "/area" : `/${locale}/area`} className="hover:underline transition-colors">
                  {t("Kastoria")}
                </Link>
              }
              text={
                <>
                  {t("Timeless, always attractive, with a changing face yet ever new, it still continues its path carved by Aeolians and Macedonians, Romans and Christians. Built stone by stone from its towering castles to its Byzantine churches and mansions that stand patiently against the tide of time. In very few places did Byzantium seal its essence so deeply as in this city. Kastoria doesn't just have history; it is history itself, fully alive, standing before you. It overwhelms you, challenges you to gather it piece by piece from what was scattered by the hands of conquerors, barbarians, and the passage of time.")}
                  {" "}
                  <Link href={locale === "el" ? "/rooms" : `/${locale}/rooms`} className="underline hover:text-white transition-colors decoration-white/50 hover:decoration-white">
                    {t("Discover our rooms")}
                  </Link> {t("near this historic city.")}
                </>
              }
            />
        </div>
      </div>

      <div
        className="relative min-h-[25rem] md:min-h-[31.25rem] lg:h-screen mt-4 md:mt-0"
        style={{
          backgroundImage: "url(/images/area/area-right.webp)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          className="absolute right-4 top-4 bottom-4 md:right-[3.125rem] md:top-[3.125rem] md:bottom-auto lg:right-8 lg:top-8 lg:bottom-auto left-4 md:left-[3.125rem] lg:left-8 w-auto min-h-[22.1875rem] px-6 py-8 md:px-8 md:py-10 flex items-start bg-ui-card/85 max-w-full box-border"
          style={{ minWidth: 0 }}
        >
            <AreaContentBlock
              variant="homepage"
              headingLevel="h2"
              title={
                <Link href={locale === "el" ? "/area" : `/${locale}/area`} className="hover:underline transition-colors">
                  {t("Grammos")}
                </Link>
              }
              text={
                <>
                  {t("The mountainous mass of Grammos is a place of incomparable beauty and perhaps one of the few unexplored destinations in Greece. Here you will encounter extensive meadows, alpine rivers, virgin forests. The hikes on the labyrinthine paths of the mountain are exciting, full of surprises, and offer unique emotions to the hiker.")}
                  {" "}
                  <Link href={locale === "el" ? "/where" : `/${locale}/where`} className="underline hover:text-white transition-colors decoration-white/50 hover:decoration-white">
                    {t("Find us")}
                  </Link> {t("in this beautiful region.")}
                </>
              }
            />
        </div>
      </div>
    </section>
  );
}

